// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_jd-6";
export var emphasizeQuantity = "_jd-3";
export var flatBottomCorners = "_jd-5";
export var productImage = "_jd-0";
export var quantityContainer = "_jd-2";
export var tooltip = "_jd-1";
export var wrapAndEllipsesOverflow = "_jd-4";